import { TxInterface } from "interfaces/tx.interface";

export enum TxActionTypes {
  FETCH_TX_REQUEST = "FETCH_TX_REQUEST",
  FETCH_TX_SUCCESS = "FETCH_TX_SUCCESS",
  FETCH_TX_FAILURE = "FETCH_TX_FAILURE",
}

// Action interfaces
export interface FetchTxRequestAction {
  type: TxActionTypes.FETCH_TX_REQUEST;
  payload: {
    signature: string;
  };
}

export interface FetchTxSuccessAction {
  type: TxActionTypes.FETCH_TX_SUCCESS;
  payload: TxInterface;
}

export interface FetchTxFailureAction {
  type: TxActionTypes.FETCH_TX_FAILURE;
  payload: string;
}

// Action creators
export const fetchTxRequest = (signature: string): FetchTxRequestAction => ({
  type: TxActionTypes.FETCH_TX_REQUEST,
  payload: { signature },
});

export const fetchTxSuccess = (data: TxInterface): FetchTxSuccessAction => ({
  type: TxActionTypes.FETCH_TX_SUCCESS,
  payload: data,
});

export const fetchTxFailure = (error: string): FetchTxFailureAction => ({
  type: TxActionTypes.FETCH_TX_FAILURE,
  payload: error,
});

export type TxActions =
  | FetchTxRequestAction
  | FetchTxSuccessAction
  | FetchTxFailureAction;
